import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import FooterSection from '../home-landing/components/FooterSection';
import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';

const Contact = () => {
  const navigate = useNavigate();
  const [cartCount] = useState(0);
  const [user] = useState(null);

  const handleCartClick = () => {
    navigate('/shopping-cart');
  };

  const handleAccountClick = (action) => {
    switch (action) {
      case 'login':navigate('/login');
        break;
      case 'register':navigate('/register');
        break;
      case 'account':navigate('/user-account');
        break;
      case 'logout':localStorage.removeItem('currentUser');
        break;
      default:
        break;
    }
  };

  const handleSearch = (searchTerm) => {
    navigate('/menu-catalog', { state: { searchQuery: searchTerm } });
  };

  const handleLogout = () => {
    localStorage.removeItem('currentUser');
  };

  const contactMethods = [
  {
    icon: 'Phone',
    title: 'Call Us',
    details: [
    { location: 'Chapel Hill', phone: '(984) 999-4537', tel: '+19849994537' },
    { location: 'Durham', phone: '(919) 973-0028', tel: '+19199730028' }],

    actionLabel: 'Call Now'
  },
  {
    icon: 'Mail',
    title: 'Email Us',
    details: ['kahloveramexican@gmail.com'],
    action: 'mailto:kahloveramexican@gmail.com',
    actionLabel: 'Send Email'
  },
  {
    icon: 'MessageCircle',
    title: 'Social Media',
    details: ['@kahloveramx'],
    action: 'https://www.instagram.com/kahloveramx/',
    actionLabel: 'Follow Us'
  }];


  const locations = [
  {
    name: 'Chapel Hill',
    address: '504 Meadowmont Village Cir',
    city: 'Chapel Hill, NC 27517',
    hours: 'Mon-Thu: 11AM-9PM, Fri-Sun: 11AM-10PM',
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4',
    imageAlt: 'Kahlovera Chapel Hill location exterior with welcoming entrance and outdoor seating area',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=504+Meadowmont+Village+Cir+Chapel+Hill+NC+27517'
  },
  {
    name: 'Durham',
    address: '2812 Erwin Road',
    city: 'Durham, NC 27705',
    hours: 'Mon-Thu: 11AM-9PM, Fri-Sun: 11AM-10PM',
    image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5',
    imageAlt: 'Kahlovera Durham location exterior with modern storefront and vibrant signage',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=2812+Erwin+Road+Durham+NC+27705'
  }];


  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Header
        cartCount={cartCount}
        user={user}
        onCartClick={handleCartClick}
        onAccountClick={handleAccountClick}
        onSearch={handleSearch}
        onLogout={handleLogout} />
      {/* Hero Section */}
      <section className="relative min-h-[60vh] md:min-h-[50vh] flex items-center justify-center overflow-hidden pt-16">
        <div className="absolute inset-0 z-0">
          <Image
            src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d"
            alt="Welcoming restaurant exterior with warm lighting and inviting entrance showcasing Kahlovera's hospitality"
            className="w-full h-full object-cover" />

          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}>

            <div className="inline-flex items-center space-x-2 bg-accent px-4 py-2 rounded-full mb-6">
              <Icon name="Mail" size={20} className="text-accent-foreground" />
              <span className="text-accent-foreground font-body font-bold">GET IN TOUCH</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-white mb-6">
              Contact <span className="text-accent">Us</span>
            </h1>

            <p className="text-xl text-white/90 font-body max-w-3xl mx-auto">
              We're here to help! Reach out with questions, feedback, or reservation requests.
            </p>
          </motion.div>
        </div>
      </section>
      {/* Contact Methods */}
      <section className="py-20 bg-background pb-10 pt-[30px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            {contactMethods?.map((method, index) =>
            <motion.div
              key={method?.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-card rounded-2xl shadow-warm p-8 text-center hover:shadow-warm-lg transition-all duration-300 pt-0">

                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Icon name={method?.icon} size={32} className="text-primary" />
                </div>
                <h3 className="text-xl font-heading font-bold text-foreground mb-3">
                  {method?.title}
                </h3>
                {method?.icon === 'Phone' ?
              <div className="space-y-3">
                    {method?.details?.map((detail, idx) =>
                <a
                  key={idx}
                  href={`tel:${detail?.tel}`}
                  className="flex items-center justify-center space-x-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-body font-semibold hover:bg-primary/90 transition-colors duration-300">

                        <span>{detail?.location}</span>
                      </a>
                )}
                  </div> :

              <>
                    {method?.details?.map((detail, idx) =>
                <p key={idx} className="text-muted-foreground font-body mb-4">
                        {detail}
                      </p>
                )}
                    <a
                  href={method?.action}
                  target={method?.action?.startsWith('http') ? '_blank' : undefined}
                  rel={method?.action?.startsWith('http') ? 'noopener noreferrer' : undefined}
                  className="inline-flex items-center space-x-2 text-primary hover:text-primary/80 font-body font-medium transition-colors duration-200">

                      <span>{method?.actionLabel}</span>
                      <Icon name="ArrowRight" size={16} />
                    </a>
                  </>
              }
              </motion.div>
            )}
          </div>
        </div>
      </section>
      {/* Locations */}
      <section className="py-20 bg-muted/30 pt-5 pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16">

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-4">
              Our <span className="text-primary">Locations</span>
            </h2>
            <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
              Visit us at either of our two locations in the Triangle area
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8">
            {locations?.map((location, index) =>
            <motion.div
              key={location?.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-card rounded-2xl shadow-warm overflow-hidden hover:shadow-warm-lg transition-all duration-300">

                <div className="relative h-48">
                  <Image
                  src={location?.image}
                  alt={location?.imageAlt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-heading font-bold text-foreground mb-4">
                    {location?.name}
                  </h3>
                  <div className="space-y-3 mb-6">
                    <div className="flex items-start space-x-3">
                      <Icon name="MapPin" size={20} className="text-primary flex-shrink-0 mt-1" />
                      <div>
                        <p className="font-body text-foreground">{location?.address}</p>
                        <p className="font-body text-foreground">{location?.city}</p>
                      </div>
                    </div>
                  </div>
                  <a
                  href={location?.mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-body font-semibold hover:bg-primary/90 transition-colors duration-300">

                    <Icon name="Navigation" size={20} />
                    <span>Get Directions</span>
                  </a>
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </section>
      {/* Footer */}
      <FooterSection />
    </div>
  );

};

export default Contact;